export default "__VITE_ASSET__DR9pDO8N__"